import api from './api';

const cleanParams = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  return query.toString();
};

const reportsService = {
  getHRPerformanceReport: async (params = {}) => {
    const response = await api.get(`/reports/hr-performance?${cleanParams(params)}`);
    return response.data;
  },

  getSummaryReport: async () => {
    const response = await api.get('/reports/summary');
    return response.data;
  },

  getInterviewReport: async (params = {}) => {
    const response = await api.get(`/reports/interviews?${cleanParams(params)}`);
    return response.data;
  },

  getExamReport: async (params = {}) => {
    const response = await api.get(`/reports/exams?${cleanParams(params)}`);
    return response.data;
  },

  getPaymentReport: async (params = {}) => {
    const response = await api.get(`/reports/payments?${cleanParams(params)}`);
    return response.data;
  }
};

export default reportsService;
